<div class="home-container">
  <div class="title-container">
    <h1 class="title">Here's what you can do here:</h1>
  </div>
  <app-card-grid [items]="menuItems" [containerWidth]="'1200px'"></app-card-grid>
</div>
